const isExperimentEnabled = (experimentKey: string, group: string): boolean =>
  !!(window as any).dataLayer?.[0]?.u?.tg?.stg?.includes(`${experimentKey}_${group}`.toLowerCase());
export default isExperimentEnabled;
